import { useEffect, useState } from "react";

export function useVisibleCount(itemCount: number, withPeek: boolean) {
  const [count, setCount] = useState(1);

  useEffect(() => {
    function update() {
      const w = window.innerWidth;
      if (w < 600)
        setCount(1); // portrait mobile
      else if (w < 1024)
        setCount(1); // landscape mobile, small tablet
      else if (itemCount === 2)
        setCount(2); // always show 2 side by side
      else setCount(withPeek ? 2.2 : 2); // 2.2 means peek third card
    }
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, [itemCount, withPeek]);
  return count;
}
